// ─────────────────────────────────────────────────────────────────────────────
// geo.ts — Countries with primary IANA timezone + curated timezone list
// ─────────────────────────────────────────────────────────────────────────────

export interface Country {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  timezone: string; // Primary IANA timezone for this country
}

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afghanistan", timezone: "Asia/Kabul" },
  { code: "AL", name: "Albania", timezone: "Europe/Tirane" },
  { code: "DZ", name: "Algeria", timezone: "Africa/Algiers" },
  { code: "AR", name: "Argentina", timezone: "America/Argentina/Buenos_Aires" },
  { code: "AM", name: "Armenia", timezone: "Asia/Yerevan" },
  { code: "AU", name: "Australia", timezone: "Australia/Sydney" },
  { code: "AT", name: "Austria", timezone: "Europe/Vienna" },
  { code: "AZ", name: "Azerbaijan", timezone: "Asia/Baku" },
  { code: "BH", name: "Bahrain", timezone: "Asia/Bahrain" },
  { code: "BD", name: "Bangladesh", timezone: "Asia/Dhaka" },
  { code: "BY", name: "Belarus", timezone: "Europe/Minsk" },
  { code: "BE", name: "Belgium", timezone: "Europe/Brussels" },
  { code: "BZ", name: "Belize", timezone: "America/Belize" },
  { code: "BO", name: "Bolivia", timezone: "America/La_Paz" },
  { code: "BA", name: "Bosnia and Herzegovina", timezone: "Europe/Sarajevo" },
  { code: "BR", name: "Brazil", timezone: "America/Sao_Paulo" },
  { code: "BN", name: "Brunei", timezone: "Asia/Brunei" },
  { code: "BG", name: "Bulgaria", timezone: "Europe/Sofia" },
  { code: "KH", name: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { code: "CM", name: "Cameroon", timezone: "Africa/Douala" },
  { code: "CA", name: "Canada", timezone: "America/Toronto" },
  { code: "CL", name: "Chile", timezone: "America/Santiago" },
  { code: "CN", name: "China", timezone: "Asia/Shanghai" },
  { code: "CO", name: "Colombia", timezone: "America/Bogota" },
  { code: "CR", name: "Costa Rica", timezone: "America/Costa_Rica" },
  { code: "HR", name: "Croatia", timezone: "Europe/Zagreb" },
  { code: "CU", name: "Cuba", timezone: "America/Havana" },
  { code: "CY", name: "Cyprus", timezone: "Asia/Nicosia" },
  { code: "CZ", name: "Czech Republic", timezone: "Europe/Prague" },
  { code: "DK", name: "Denmark", timezone: "Europe/Copenhagen" },
  { code: "DO", name: "Dominican Republic", timezone: "America/Santo_Domingo" },
  { code: "EC", name: "Ecuador", timezone: "America/Guayaquil" },
  { code: "EG", name: "Egypt", timezone: "Africa/Cairo" },
  { code: "SV", name: "El Salvador", timezone: "America/El_Salvador" },
  { code: "EE", name: "Estonia", timezone: "Europe/Tallinn" },
  { code: "ET", name: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { code: "FI", name: "Finland", timezone: "Europe/Helsinki" },
  { code: "FR", name: "France", timezone: "Europe/Paris" },
  { code: "GE", name: "Georgia", timezone: "Asia/Tbilisi" },
  { code: "DE", name: "Germany", timezone: "Europe/Berlin" },
  { code: "GH", name: "Ghana", timezone: "Africa/Accra" },
  { code: "GR", name: "Greece", timezone: "Europe/Athens" },
  { code: "GT", name: "Guatemala", timezone: "America/Guatemala" },
  { code: "HN", name: "Honduras", timezone: "America/Tegucigalpa" },
  { code: "HK", name: "Hong Kong", timezone: "Asia/Hong_Kong" },
  { code: "HU", name: "Hungary", timezone: "Europe/Budapest" },
  { code: "IS", name: "Iceland", timezone: "Atlantic/Reykjavik" },
  { code: "IN", name: "India", timezone: "Asia/Kolkata" },
  { code: "ID", name: "Indonesia", timezone: "Asia/Jakarta" },
  { code: "IR", name: "Iran", timezone: "Asia/Tehran" },
  { code: "IQ", name: "Iraq", timezone: "Asia/Baghdad" },
  { code: "IE", name: "Ireland", timezone: "Europe/Dublin" },
  { code: "IL", name: "Israel", timezone: "Asia/Jerusalem" },
  { code: "IT", name: "Italy", timezone: "Europe/Rome" },
  { code: "JM", name: "Jamaica", timezone: "America/Jamaica" },
  { code: "JP", name: "Japan", timezone: "Asia/Tokyo" },
  { code: "JO", name: "Jordan", timezone: "Asia/Amman" },
  { code: "KZ", name: "Kazakhstan", timezone: "Asia/Almaty" },
  { code: "KE", name: "Kenya", timezone: "Africa/Nairobi" },
  { code: "KW", name: "Kuwait", timezone: "Asia/Kuwait" },
  { code: "KG", name: "Kyrgyzstan", timezone: "Asia/Bishkek" },
  { code: "LA", name: "Laos", timezone: "Asia/Vientiane" },
  { code: "LV", name: "Latvia", timezone: "Europe/Riga" },
  { code: "LB", name: "Lebanon", timezone: "Asia/Beirut" },
  { code: "LY", name: "Libya", timezone: "Africa/Tripoli" },
  { code: "LT", name: "Lithuania", timezone: "Europe/Vilnius" },
  { code: "LU", name: "Luxembourg", timezone: "Europe/Luxembourg" },
  { code: "MO", name: "Macau", timezone: "Asia/Macau" },
  { code: "MK", name: "North Macedonia", timezone: "Europe/Skopje" },
  { code: "MY", name: "Malaysia", timezone: "Asia/Kuala_Lumpur" },
  { code: "MV", name: "Maldives", timezone: "Indian/Maldives" },
  { code: "MT", name: "Malta", timezone: "Europe/Malta" },
  { code: "MX", name: "Mexico", timezone: "America/Mexico_City" },
  { code: "MD", name: "Moldova", timezone: "Europe/Chisinau" },
  { code: "MN", name: "Mongolia", timezone: "Asia/Ulaanbaatar" },
  { code: "MA", name: "Morocco", timezone: "Africa/Casablanca" },
  { code: "MZ", name: "Mozambique", timezone: "Africa/Maputo" },
  { code: "MM", name: "Myanmar", timezone: "Asia/Rangoon" },
  { code: "NP", name: "Nepal", timezone: "Asia/Kathmandu" },
  { code: "NL", name: "Netherlands", timezone: "Europe/Amsterdam" },
  { code: "NZ", name: "New Zealand", timezone: "Pacific/Auckland" },
  { code: "NI", name: "Nicaragua", timezone: "America/Managua" },
  { code: "NG", name: "Nigeria", timezone: "Africa/Lagos" },
  { code: "NO", name: "Norway", timezone: "Europe/Oslo" },
  { code: "OM", name: "Oman", timezone: "Asia/Muscat" },
  { code: "PK", name: "Pakistan", timezone: "Asia/Karachi" },
  { code: "PA", name: "Panama", timezone: "America/Panama" },
  { code: "PY", name: "Paraguay", timezone: "America/Asuncion" },
  { code: "PE", name: "Peru", timezone: "America/Lima" },
  { code: "PH", name: "Philippines", timezone: "Asia/Manila" },
  { code: "PL", name: "Poland", timezone: "Europe/Warsaw" },
  { code: "PT", name: "Portugal", timezone: "Europe/Lisbon" },
  { code: "QA", name: "Qatar", timezone: "Asia/Qatar" },
  { code: "RO", name: "Romania", timezone: "Europe/Bucharest" },
  { code: "RU", name: "Russia", timezone: "Europe/Moscow" },
  { code: "SA", name: "Saudi Arabia", timezone: "Asia/Riyadh" },
  { code: "SN", name: "Senegal", timezone: "Africa/Dakar" },
  { code: "RS", name: "Serbia", timezone: "Europe/Belgrade" },
  { code: "SG", name: "Singapore", timezone: "Asia/Singapore" },
  { code: "SK", name: "Slovakia", timezone: "Europe/Bratislava" },
  { code: "SI", name: "Slovenia", timezone: "Europe/Ljubljana" },
  { code: "ZA", name: "South Africa", timezone: "Africa/Johannesburg" },
  { code: "KR", name: "South Korea", timezone: "Asia/Seoul" },
  { code: "ES", name: "Spain", timezone: "Europe/Madrid" },
  { code: "LK", name: "Sri Lanka", timezone: "Asia/Colombo" },
  { code: "SD", name: "Sudan", timezone: "Africa/Khartoum" },
  { code: "SE", name: "Sweden", timezone: "Europe/Stockholm" },
  { code: "CH", name: "Switzerland", timezone: "Europe/Zurich" },
  { code: "SY", name: "Syria", timezone: "Asia/Damascus" },
  { code: "TW", name: "Taiwan", timezone: "Asia/Taipei" },
  { code: "TJ", name: "Tajikistan", timezone: "Asia/Dushanbe" },
  { code: "TZ", name: "Tanzania", timezone: "Africa/Dar_es_Salaam" },
  { code: "TH", name: "Thailand", timezone: "Asia/Bangkok" },
  { code: "TN", name: "Tunisia", timezone: "Africa/Tunis" },
  { code: "TR", name: "Turkey", timezone: "Europe/Istanbul" },
  { code: "TM", name: "Turkmenistan", timezone: "Asia/Ashgabat" },
  { code: "UG", name: "Uganda", timezone: "Africa/Kampala" },
  { code: "UA", name: "Ukraine", timezone: "Europe/Kiev" },
  { code: "AE", name: "United Arab Emirates", timezone: "Asia/Dubai" },
  { code: "GB", name: "United Kingdom", timezone: "Europe/London" },
  { code: "US", name: "United States", timezone: "America/New_York" },
  { code: "UY", name: "Uruguay", timezone: "America/Montevideo" },
  { code: "UZ", name: "Uzbekistan", timezone: "Asia/Tashkent" },
  { code: "VE", name: "Venezuela", timezone: "America/Caracas" },
  { code: "VN", name: "Vietnam", timezone: "Asia/Ho_Chi_Minh" },
  { code: "YE", name: "Yemen", timezone: "Asia/Aden" },
  { code: "ZM", name: "Zambia", timezone: "Africa/Lusaka" },
  { code: "ZW", name: "Zimbabwe", timezone: "Africa/Harare" },
];

// ── Curated IANA timezone list ────────────────────────────────────────────────

export interface TimezoneOption {
  value: string; // IANA timezone ID
  label: string; // Human-readable display
}

export const TIMEZONES: TimezoneOption[] = [
  // UTC
  { value: "UTC", label: "UTC (UTC+0)" },
  // Americas
  { value: "Pacific/Honolulu", label: "Hawaii (UTC−10)" },
  { value: "America/Anchorage", label: "Alaska (UTC−9)" },
  { value: "America/Los_Angeles", label: "Pacific Time — US & Canada (UTC−8)" },
  { value: "America/Denver", label: "Mountain Time — US & Canada (UTC−7)" },
  { value: "America/Chicago", label: "Central Time — US & Canada (UTC−6)" },
  { value: "America/New_York", label: "Eastern Time — US & Canada (UTC−5)" },
  { value: "America/Sao_Paulo", label: "Brazil (UTC−3)" },
  { value: "America/Argentina/Buenos_Aires", label: "Argentina (UTC−3)" },
  { value: "America/Bogota", label: "Colombia (UTC−5)" },
  { value: "America/Lima", label: "Peru (UTC−5)" },
  { value: "America/Mexico_City", label: "Mexico City (UTC−6)" },
  { value: "America/Toronto", label: "Canada — Toronto (UTC−5)" },
  { value: "America/Vancouver", label: "Canada — Vancouver (UTC−8)" },
  { value: "America/Caracas", label: "Venezuela (UTC−4)" },
  { value: "America/Santiago", label: "Chile (UTC−4)" },
  { value: "America/La_Paz", label: "Bolivia (UTC−4)" },
  // Europe
  { value: "Atlantic/Reykjavik", label: "Iceland (UTC+0)" },
  { value: "Europe/London", label: "London (UTC+0/+1)" },
  { value: "Europe/Dublin", label: "Dublin (UTC+0/+1)" },
  { value: "Europe/Lisbon", label: "Lisbon (UTC+0/+1)" },
  { value: "Europe/Paris", label: "Paris / Berlin / Rome (UTC+1/+2)" },
  { value: "Europe/Berlin", label: "Berlin (UTC+1/+2)" },
  { value: "Europe/Madrid", label: "Madrid (UTC+1/+2)" },
  { value: "Europe/Rome", label: "Rome (UTC+1/+2)" },
  { value: "Europe/Amsterdam", label: "Amsterdam (UTC+1/+2)" },
  { value: "Europe/Brussels", label: "Brussels (UTC+1/+2)" },
  { value: "Europe/Zurich", label: "Zurich (UTC+1/+2)" },
  { value: "Europe/Warsaw", label: "Warsaw (UTC+1/+2)" },
  { value: "Europe/Stockholm", label: "Stockholm (UTC+1/+2)" },
  { value: "Europe/Oslo", label: "Oslo (UTC+1/+2)" },
  { value: "Europe/Copenhagen", label: "Copenhagen (UTC+1/+2)" },
  { value: "Europe/Vienna", label: "Vienna (UTC+1/+2)" },
  { value: "Europe/Athens", label: "Athens (UTC+2/+3)" },
  { value: "Europe/Helsinki", label: "Helsinki (UTC+2/+3)" },
  { value: "Europe/Bucharest", label: "Bucharest (UTC+2/+3)" },
  { value: "Europe/Kiev", label: "Kyiv (UTC+2/+3)" },
  { value: "Europe/Istanbul", label: "Istanbul (UTC+3)" },
  { value: "Europe/Moscow", label: "Moscow (UTC+3)" },
  // Africa
  { value: "Africa/Cairo", label: "Cairo (UTC+2)" },
  { value: "Africa/Johannesburg", label: "Johannesburg (UTC+2)" },
  { value: "Africa/Lagos", label: "Lagos (UTC+1)" },
  { value: "Africa/Nairobi", label: "Nairobi (UTC+3)" },
  { value: "Africa/Casablanca", label: "Casablanca (UTC+1)" },
  // Asia & Middle East
  { value: "Asia/Dubai", label: "Dubai / Abu Dhabi (UTC+4)" },
  { value: "Asia/Riyadh", label: "Saudi Arabia (UTC+3)" },
  { value: "Asia/Baghdad", label: "Baghdad (UTC+3)" },
  { value: "Asia/Tehran", label: "Tehran (UTC+3:30)" },
  { value: "Asia/Karachi", label: "Karachi (UTC+5)" },
  { value: "Asia/Kolkata", label: "India (UTC+5:30)" },
  { value: "Asia/Colombo", label: "Sri Lanka (UTC+5:30)" },
  { value: "Asia/Kathmandu", label: "Nepal (UTC+5:45)" },
  { value: "Asia/Dhaka", label: "Bangladesh (UTC+6)" },
  { value: "Asia/Almaty", label: "Kazakhstan (UTC+6)" },
  { value: "Asia/Rangoon", label: "Myanmar (UTC+6:30)" },
  { value: "Asia/Bangkok", label: "Bangkok / Hanoi (UTC+7)" },
  { value: "Asia/Jakarta", label: "Jakarta (UTC+7)" },
  { value: "Asia/Singapore", label: "Singapore (UTC+8)" },
  { value: "Asia/Kuala_Lumpur", label: "Kuala Lumpur (UTC+8)" },
  { value: "Asia/Shanghai", label: "China (UTC+8)" },
  { value: "Asia/Hong_Kong", label: "Hong Kong (UTC+8)" },
  { value: "Asia/Taipei", label: "Taiwan (UTC+8)" },
  { value: "Asia/Seoul", label: "Seoul (UTC+9)" },
  { value: "Asia/Tokyo", label: "Tokyo (UTC+9)" },
  // Pacific
  { value: "Australia/Perth", label: "Perth (UTC+8)" },
  { value: "Australia/Darwin", label: "Darwin (UTC+9:30)" },
  { value: "Australia/Adelaide", label: "Adelaide (UTC+9:30)" },
  { value: "Australia/Sydney", label: "Sydney / Melbourne (UTC+10/+11)" },
  { value: "Australia/Brisbane", label: "Brisbane (UTC+10)" },
  { value: "Pacific/Auckland", label: "New Zealand (UTC+12/+13)" },
  { value: "Pacific/Fiji", label: "Fiji (UTC+12)" },
];

/** Returns the best-guess user timezone from the browser */
export function detectBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
